import axios from "axios";

const LogueMovimientos = async (usuario, accion) => {
  console.group("🔎 DEBUG - LogueMovimientos");

  try {
    const baseURL = process.env.REACT_APP_BASEURL;
    const endpoint = "registroLogsUsuarios";

    const identificacion =
      usuario?.identificacion ||
      usuario?.dni ||
      "";

    const token = btoa(
      `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
    );

    console.log("👤 Usuario recibido:", usuario);
    console.log("🪪 Identificación:", identificacion);
    console.log("📝 Acción:", accion);
    console.log("🌐 Base URL:", baseURL);
    console.log("📡 Endpoint:", endpoint);
    console.log("🔐 Autenticación utilizada: Basic");
    console.log("🔑 REACT_APP_KEY configurada:", !!process.env.REACT_APP_KEY);
    console.log("🔑 REACT_APP_PASS configurada:", !!process.env.REACT_APP_PASS);

    const clients = axios.create({
      baseURL,
      headers: {
        Authorization: `Basic ${token}`,
      },
    });

    const payload = {
      usuario: identificacion,
      accion,
    };

    console.log("📤 Datos enviados:", payload);
    console.time("⏱️ Tiempo registro log");

    const trans = await clients.post(endpoint, payload);

    console.timeEnd("⏱️ Tiempo registro log");

    console.log("✅ PETICIÓN EXITOSA");
    console.log("📊 HTTP Status:", trans.status);
    console.log("📥 Respuesta backend:", trans.data);

    return trans.data;

  } catch (error) {
    console.timeEnd("⏱️ Tiempo registro log");

    console.error("❌ ERROR REGISTRANDO LOG");

    console.log("📊 HTTP Status:", error.response?.status);
    console.log("📥 Respuesta backend:", error.response?.data);
    console.log("🌐 URL:", error.config?.url);
    console.log("📡 Método:", error.config?.method);
    console.log("📝 Mensaje:", error.message);

    if (error.response?.status === 401) {
      console.warn(
        "🚨 El servidor rechazó la autenticación de registroLogsUsuarios"
      );
    }

    if (!error.response) {
      console.warn(
        "🚨 No se recibió una respuesta HTTP del servidor"
      );
    }

    return null;

  } finally {
    console.groupEnd();
  }
};

export default LogueMovimientos;